import { ResponsiveProductImage } from "./ResponsiveProductImage";
import { useSelector } from "react-redux";
import {
  selectOwnerCode,
  selectResizeURL,
  selectSizeBreakPoints,
  selectSrcSetWidths,
  selectDefaultWidth
} from "../store/orderingSlice";

export function StyleItemThumb({ styleItem, className = "thumbnail"  }) {
  const owner_code = useSelector(selectOwnerCode);
  const resize_url = useSelector(selectResizeURL);
  const size_breakpoints = useSelector(selectSizeBreakPoints);
  const srcset_widths = useSelector(selectSrcSetWidths);
  const default_width = useSelector(selectDefaultWidth);

  return (
    <ResponsiveProductImage
      resizeURL={resize_url}
      path={owner_code + "-" + styleItem.style_item_code + "-1.jpg"}
      srcsetWidths={srcset_widths}
      sizeBreakpoints={size_breakpoints}
      defaultWidth={default_width}
      alt={styleItem.style_item_name}
      className={className} />
  );
}
